import React, { useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import {
  Container,
  Grid,
  Box,
  Select,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";

import GroupReport from "../reports/group.report";
import CategoryReport from "../reports/category.report";
import ProductReport from "../reports/product.report";
import OrderMethodReport from "../reports/ordermethod.report";
import PaymentMethodReport from "../reports/paymentmethod.report";
import SalesMethodReport from "../reports/salesmethod.report";
import ZReport from "../reports/z.report";
import ZlistReport from "../reports/zlist.report";

export default function ReportsScreen() {
  const [report, setReport] = useState("Z analysis");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [makeTheReport, setMakeTheReport] = useState(false);

  const handleReportChange = (event) => {
    setReport(event.target.value);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    pageStyle: { marginLeft: "8px" },
  });

  const contentRef = useRef(null);

  return (
    <Box display="flex" justifyContent="center" height="100vh">
      <Container maxWidth="100%">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Select value={report} onChange={handleReportChange} fullWidth>
              <MenuItem value="Z analysis">Z analysis</MenuItem>
              <MenuItem value="Z invoice list">Z invoice list</MenuItem>
              <MenuItem value="Sales by order method">
                Sales by order method
              </MenuItem>
              <MenuItem value="Sales by payment method">
                Sales by payment method
              </MenuItem>
              <MenuItem value="Sales by sales method">
                Sales by sales method
              </MenuItem>
              <MenuItem value="Product sales analysis">
                Product sales analysis
              </MenuItem>
              <MenuItem value="Category sales analysis">
                Category sales analysis
              </MenuItem>
              <MenuItem value="Group sales analysis">
                Group sales analysis
              </MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <TextField
              label="From"
              type="date"
              value={fromDate}
              onChange={handleFromDateChange}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <TextField
              label="To"
              type="date"
              value={toDate}
              onChange={handleToDateChange}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 8,
            }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setMakeTheReport(true);
              }}
            >
              Make the report
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                handlePrint(null, () => contentRef.current);
              }}
            >
              Print the report
            </Button>
          </Grid>
          <Grid item xs={12} ref={contentRef} sx={{ margin: 2 }}>
            {report === "Group sales analysis" && makeTheReport ? (
              <GroupReport fromDate={fromDate} toDate={toDate} />
            ) : report === "Category sales analysis" && makeTheReport ? (
              <CategoryReport fromDate={fromDate} toDate={toDate} />
            ) : report === "Product sales analysis" && makeTheReport ? (
              <ProductReport fromDate={fromDate} toDate={toDate} />
            ) : report === "Sales by order method" && makeTheReport ? (
              <OrderMethodReport fromDate={fromDate} toDate={toDate} />
            ) : report === "Sales by payment method" && makeTheReport ? (
              <PaymentMethodReport fromDate={fromDate} toDate={toDate} />
            ) : report === "Sales by sales method" && makeTheReport ? (
              <SalesMethodReport fromDate={fromDate} toDate={toDate} />
            ) : report === "Z analysis" && makeTheReport ? (
              <ZReport fromDate={fromDate} toDate={toDate} />
            ) : report === "Z invoice list" && makeTheReport ? (
              <ZlistReport fromDate={fromDate} toDate={toDate} />
            ) : (
              <div>No report ready</div>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
